/**
 * File: addLeadDraftUtils.ts
 * Path: apps/admin/src/shared/utils/addLeadDraftUtils.ts
 * Description: The Add lead form's draft, its checks, and how it becomes the
 * LeadDetails the repository stores.
 */

import { formatPhone, safeWebUrl, type LeadDetails, type LeadSource } from "@idk/config";
import { parseRand, validateLeadFields, type LeadFieldErrors } from "./leadFieldsUtils";

export interface AddLeadDraft {
  name: string;
  contactName: string;
  phone: string;
  email: string;
  website: string;
  area: string;
  niche: string;
  /** Kept as typed; parsed on save. */
  value: string;
  nextFollowUp: string;
  source: LeadSource;
  /** The partner who sent them, when the source is a referral. */
  affiliateId: string;
  marketingConsent: boolean;
}

export type AddLeadErrors = LeadFieldErrors;

export const EMPTY_ADD_LEAD: AddLeadDraft = {
  name: "",
  contactName: "",
  phone: "",
  email: "",
  website: "",
  area: "",
  niche: "",
  value: "",
  nextFollowUp: "",
  source: "walk_in",
  affiliateId: "",
  marketingConsent: false,
};

export const validateAddLead = (draft: AddLeadDraft): AddLeadErrors => validateLeadFields(draft);

export const toLeadDetails = (draft: AddLeadDraft): LeadDetails => ({
  name: draft.name.trim(),
  contactName: draft.contactName.trim(),
  phone: formatPhone(draft.phone),
  email: draft.email.trim(),
  website: safeWebUrl(draft.website),
  address: "",
  area: draft.area.trim(),
  niche: draft.niche.trim(),
  value: parseRand(draft.value),
  nextFollowUp: draft.nextFollowUp || null,
  doNotContact: false,
  marketingConsent: draft.marketingConsent,
});
